import PathToHomeOwnership from "./PathToHomeOwnership";

export default PathToHomeOwnership;
